import React from "react";
import styles from "./index.module.scss";
import Icons from "../../public/assets/svg/index";
import { useRouter } from "next/router";

function index(props) {
  //console.log(props, "propsss")
  const [userName, setUserName] = React.useState("");
  const router = useRouter();
  const closeIt = () => {
    props.setSuccessModal(false);
    if (props.parent == "createBot") {
      router.push("/botStore");
    }
  };

  React.useEffect(() => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    setUserName(auth.name);
  });

  return (
    <div className={styles.successContainer}>
      <div className={styles.modalBox}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>{props.data.field_title}</p>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.status}>
            <Icons name="whitetick" />
          </div>
          <div className={styles.textBody}>
            <p className={styles.texthead}>
              Hi <strong>{userName}</strong>
            </p>
            {
              props.parent == "createBot" ? <div
              className={styles.textcontent}
              
            > Successfully Created Bot with Bot ID {props.botID}</div>
            :
            <div
              className={styles.textcontent}
              dangerouslySetInnerHTML={{ __html: props.data.field_details }}
            ></div>
             }
          </div>
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.combinedBtn}>
            <span className={styles.exportListBtn} onClick={() => closeIt()}>
              Close
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
